import axiosInstance from './axiosInstance';

export const getUtentiConRuolo = () =>
    axiosInstance.get('/ruoli/utenti').then(r => r.data);

export const aggiornaRuolo = (operatoreId, ruolo_accesso) =>
    axiosInstance.patch(`/ruoli/operatori/${operatoreId}`, { ruolo_accesso }).then(r => r.data);

// Permessi dinamici per ruolo
export const getRuoliPermessi = () =>
    axiosInstance.get('/ruoli-permessi').then(r => r.data);

export const getPermessiRuolo = (ruolo) =>
    axiosInstance.get(`/ruoli-permessi/${ruolo}`).then(r => r.data);

export const aggiornaPermessiRuolo = (ruolo, permessi, label) =>
    axiosInstance.put(`/ruoli-permessi/${ruolo}`, { permessi, label }).then(r => r.data);

export const creaRuoloCustom = (ruolo, label, permessi) =>
    axiosInstance.post('/ruoli-permessi', { ruolo, label, permessi }).then(r => r.data);

export const eliminaRuoloCustom = (ruolo) =>
    axiosInstance.delete(`/ruoli-permessi/${ruolo}`).then(r => r.data);
